
import React from 'react';
import { TaskList } from '@/components/TaskList';
import { Task } from '@/types/task';

interface TasksSectionContentProps {
  tasks: Task[];
  isLoading: boolean;
  isAdmin: boolean;
  onComplete: (task: Task) => void;
  onDelete: (taskId: string) => void;
  onEdit: (taskId: string, data: any) => void;
  onReactivate: (task: Task) => void;
}

export const TasksSectionContent: React.FC<TasksSectionContentProps> = ({
  tasks,
  isLoading,
  isAdmin,
  onComplete,
  onDelete,
  onEdit,
  onReactivate
}) => {
  return (
    <div className="space-y-4 px-4">
      {isLoading ? (
        <div className="text-center text-gray-600">Loading tasks...</div>
      ) : (
        <TaskList
          tasks={tasks}
          onComplete={onComplete}
          onDelete={onDelete}
          onEdit={onEdit}
          onReactivate={onReactivate}
          isAdmin={isAdmin}
        />
      )}
    </div>
  );
};
